import React from 'react'
import styled from 'styled-components'
import Link from 'atoms/Link'
import { ProfileConsumer } from 'contexts/profile-context'
import PropTypes from 'prop-types'
import { DropdownConsumer } from 'atoms/Dropdown'
import GiftTop from '../GiftTop'
import GiftBottom from '../GiftBottom'

const Wrapper = styled.div`
    color: black;
    margin: 16px;
`

const CloseButton = styled.div`
    background-color: rgba(85, 188, 189, 1);
    border: 2px solid rgba(85, 188, 189, 1);
    border-radius: 6px;
    padding: 12px 32px;
    margin-top: 8px;
    color: #FFF;
    line-height: 16px;
    text-align: center;
    text-decoration: none;
`

function DropdownBody (props) {
  const { bonus } = props

  if (bonus === null || undefined) {
    return null
  }

  const hasLinkToContest = !!bonus.destinationUri

  const onContestLink = hasLinkToContest && (bonus.destinationUri === window.location.href)

  return (
    <ProfileConsumer>
      {profile => {
        return (
          <DropdownConsumer>
            { dropdown => {
              return (
                <Wrapper>
                  <GiftTop
                    bonusAmount={bonus.bonusAmount}
                    onUsText="On Us."
                  />
                  <GiftBottom linkUri={bonus.destinationUri} hasLinkToContest={hasLinkToContest} onContestLink={onContestLink}>
                  We&apos;ve given you a bonus!
                    <br />
                  We love our games and contests, and we think you will too.
                    <br />
                    { (!hasLinkToContest || onContestLink) &&
                      <CloseButton onClick={dropdown.close}>Got It</CloseButton>
                    }
                  </GiftBottom>
                </Wrapper>
              )
            }
            }
          </DropdownConsumer>
        )
      }}
    </ProfileConsumer>
  )
}

DropdownBody.propTypes = {
  bonus: PropTypes.object.isRequired,
}

export default DropdownBody



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/MFL10sDropdownBody/MFL10sDropdownBody.js